import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';

export const PLUGIN_NAME = 'addBuyNow';

const showSizeError = () => {
    $('#sizeError').fadeIn();
    $('#sizeErrorText').attr("role", "alert");
}

const getFitItemSizes = () => {
    return $('input[name=tryon-size-options]:checked').val();
}

const setEventListeners = ($el, opts) => {
    $el.on('click', function() {
        const code = $('#code').val();
        const size = $('#sizeValue').val();
        if (size === null || size === '') {
            showSizeError();
        } else {
            let data = {
                source: 'buynow',
                bnCode: code,
                bnSize: size,
                sectionUrl: window.rcProps.sectionUrl,
                fittingRoomSize: getFitItemSizes()
            };
            if ($('#replenish-save').is(':checked')){
                data.subscriptionInterval = $('#subscription-interval option:selected').val();
            }
            if ($(".js-counter-value").length) {
                data.quantity = $(".js-counter-value").text();
            }
            $(document).trigger('productBuyNow');
            addBuyNowProductWithData(data);
        }
    });
}

export default function addBuyNow(el, options) {
    const $el = $(el);
    setEventListeners($el, options);
}

registerJQueryPlugin(PLUGIN_NAME, addBuyNow);


// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/add-buy-now.js